//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { QueryRenderer, ReadyState } from "react-relay";
// event-annotations-list imports
import { EventPeople } from "./EventPeople";
import { eventPeopleRendererQuery } from "./EventPeopleRenderer.gql";
import { IRendererProps } from "./EventPeopleTypes";
// other components
// other internals
import { getRenderTimeZone } from "@clockwise/web-commons/src/util/time-zone.util";
import { getCurrentEnvironment } from "../../state/relay-environment";

//////////////////
// COMPONENT
//////////////////
export const EventPeopleRenderer = (props: IRendererProps) => {
  const getData = React.useCallback((readyState: ReadyState) => {
    const org =
      (readyState && readyState.props && readyState.props.org && readyState.props.org) || null;
    return {
      org,
    };
  }, []);

  const renderCallback = React.useCallback(
    (readyState: ReadyState) => {
      const { org } = getData(readyState);

      return <EventPeople event={props.event} org={org} hidePains={props.hidePains} />;
    },
    [getData, props.event, props.hidePains],
  );

  const { orgId, externalEventId, eventCalendarId } = props;
  const variables = {
    externalEventId,
    eventCalendarId,
    orgRelayId: orgId,
    timeZone: getRenderTimeZone(),
    personCalendarIds: props.event.attendees.map((attendee) => attendee.urnValue).slice(0, 15),
  };

  return (
    <QueryRenderer
      environment={getCurrentEnvironment()}
      query={eventPeopleRendererQuery}
      variables={variables}
      cacheConfig={{ force: true }}
      render={renderCallback}
    />
  );
};
